// extracted by mini-css-extract-plugin
export default {"banner":"Sobre_banner__9jG5N","tituloIntro":"Sobre_tituloIntro__6MGi0"};